import PhoneWithPrefix from './PhoneWithPrefix';

export default PhoneWithPrefix;